import { types } from 'mobx-state-tree';

import PebblesDomain from 'src/stores/pebbles/domain';
import PebblesUi from 'src/stores/pebbles/ui';

export default types.model('Pebbles', {
  domain: types.optional(PebblesDomain, {}),
  ui: types.optional(PebblesUi, {}),
});
